import React from 'react';
import {
  ArrowLeft,
  Bell,
  ChevronDown,
  MapPin,
  Search,
  ShoppingBag,
  UserRound
} from 'lucide-react';
import { cartCount, getReadableAddress, initials } from './restaurantUtils';

export default function RestaurantHeader({
  address,
  cart,
  density,
  onDensityChange,
  onBack,
  onAddress,
  onCart,
  query,
  onQueryChange,
  user
}) {
  const count = cartCount(cart);
  return (
    <header className="rc-header">
      <div className="rc-header__inner">
        <button type="button" className="rc-back" onClick={onBack} aria-label="Volver al panel principal">
          <ArrowLeft aria-hidden="true" />
          <span>PROVI</span>
        </button>

        <button type="button" className="rc-address" onClick={onAddress} aria-label={`Dirección de entrega: ${getReadableAddress(address)}`}>
          <MapPin aria-hidden="true" />
          <span>
            <small>Entregar en</small>
            <strong>{getReadableAddress(address)}</strong>
          </span>
          <ChevronDown aria-hidden="true" />
        </button>

        <label className="rc-search rc-search--desktop">
          <Search aria-hidden="true" />
          <span className="sr-only">Buscar restaurantes o productos</span>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="Buscar locales, platos y productos"
          />
        </label>

        <div className="rc-density" aria-label="Densidad de la vista">
          {['extended', 'compact'].map((option) => (
            <button
              type="button"
              key={option}
              className={density === option ? 'is-active' : ''}
              onClick={() => onDensityChange(option)}
              aria-pressed={density === option}
            >
              {option === 'extended' ? 'Extendida' : 'Compacta'}
            </button>
          ))}
        </div>

        <button type="button" className="rc-icon-button rc-header__notification" aria-label="Notificaciones" disabled>
          <Bell aria-hidden="true" />
        </button>
        <button type="button" className="rc-cart-button" onClick={onCart} aria-label={`Abrir carrito, ${count} productos`}>
          <ShoppingBag aria-hidden="true" />
          <span>Carrito</span>
          {count > 0 && <b>{count}</b>}
        </button>
        <div className="rc-profile-chip" title={user?.name || 'Mi perfil'}>
          <span>{initials(user?.name)}</span>
          <UserRound aria-hidden="true" />
        </div>
      </div>
      <label className="rc-search rc-search--mobile">
        <Search aria-hidden="true" />
        <span className="sr-only">Buscar restaurantes o productos</span>
        <input
          type="search"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="¿Qué quieres comer?"
        />
      </label>
    </header>
  );
}
